import axios from '@/axiosInterceptor';

const state = () => ({
  authorization_response: null,
  onboarding_connection: null,
  packet_id: null,
});

// getters
const getters = {};

// actions
const actions = {
  async checkUserAndOnboardingStatus({ commit, dispatch }) {
    const checkUser = await dispatch('users/refreshCurrentUser', null, {
      root: true,
    });
    if (checkUser.id > 0) {
      // user is logged in already
      // Check if user can onboard
      const onBoardRes = await dispatch(
        'onboardingPacket/getOnboardingPacket',
        null,
        { root: true }
      );
      if ([200, 201].includes(onBoardRes.status)) {
        commit('setOnboardingConnection', onBoardRes?.data?.[0]);
        return onBoardRes?.data?.[0];
      }
    }
  },
  async createAuthorization({ commit, dispatch }) {
    const clientId = localStorage.getItem('client_id');
    var redirectUri = localStorage.getItem('redirect_uri');
    const state = localStorage.getItem('state');
    const classificationIds = localStorage.getItem('classification_ids');
    const scope = localStorage.getItem('scope') || 'onboarding';
    const nonce = localStorage.getItem('nonce') || 'onboarding';
    const responseType = localStorage.getItem('response_type');
    // const classification_ids = localStorage.getItem("classification_ids");

    // to handle spaces in URL
    if (redirectUri?.includes(' ')) {
      // redirectUri = encodeURI(redirectUri);
      redirectUri = redirectUri.replace(/ /g, '');
    }

    const body = {
      client_id: clientId,
      redirect_uri: redirectUri,
      state: state,
      scope: scope,
      nonce: nonce,
      classification_ids: classificationIds,
      response_type: responseType,
    };
    // var buildParams = `response_type=${body.response_type}`;
    // buildParams += `&state=${body.state}`;
    // buildParams += `&client_id=${body.client_id}`;
    // buildParams += `&scope=${body.scope}`;
    // buildParams += `&redirect_uri=${body.redirect_url}`;
    // buildParams += `&classification_ids=${classification_ids}`;
    // buildParams += `&nonce=${body.nonce}`;
    try {
      const res = await axios.post(
        process.env.API_IDENTITY + '/oauth/authorizations',
        body
      );
      commit('setAuthorizationResponse', res.data);

      await dispatch('checkUserAndOnboardingStatus');
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [422].includes(e?.response?.status)) {
        // User needs to continue onboarding
        // check current user
        if (
          e?.response?.data?.message ===
            'please complete onboarding packet before continuing' &&
          e?.response?.data?.onboarding_packet_id > 0
        ) {
          commit('setPacketId', e?.response?.data?.onboarding_packet_id);
        }
        await dispatch('checkUserAndOnboardingStatus');
        return e.response;
      } else if (axios.isAxiosError(e) && [401].includes(e?.response?.status)) {
        // user needs to login
        return e.response;
      } else if (axios.isAxiosError(e) && [423].includes(e?.response?.status)) {
        // user needs to login
        return e.response;
      } else if (axios.isAxiosError(e) && [424].includes(e?.response?.status)) {
        // fail rules assessment
        return e.response;
      } else if (axios.isAxiosError(e) && [400].includes(e?.response?.status)) {
        // something is wrong with the oauth link
        return e.response;
      } else if (axios.isAxiosError(e) && [403].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async newAuthorization({ commit, dispatch }) {
    const clientId = localStorage.getItem('client_id');
    var redirectUri = localStorage.getItem('redirect_uri');
    const state = localStorage.getItem('state');
    const classification_ids = localStorage.getItem('classification_ids');
    // const scope = localStorage.getItem("scope");
    const nonce = localStorage.getItem('nonce');
    const scope = localStorage.getItem('scope') || 'onboarding';
    const responseType = localStorage.getItem('response_type');

    // to handle spaces in URL
    // to handle spaces in URL
    if (redirectUri?.includes(' ')) {
      // redirectUri = encodeURI(redirectUri);
      redirectUri = redirectUri.replace(/ /g, '');
    }

    const body = {
      client_id: clientId,
      redirect_uri: redirectUri,
      classification_ids: classification_ids,
      state: state,
      scope: scope,
      nonce: nonce,
      response_type: responseType,
    };
    // var buildParams = `response_type=${body.response_type}`;
    // buildParams += `&state=${body.state}`;
    // buildParams += `&client_id=${body.client_id}`;
    // buildParams += `&scope=${body.scope}`;
    // buildParams += `&redirect_uri=${body.redirect_url}`;
    // buildParams += `&classification_ids=${classification_ids}`;
    // buildParams += `&nonce=${body.nonce}`;
    try {
      const res = await axios.patch(
        process.env.API_IDENTITY + '/oauth/authorizations',
        body
      );
      commit('setAuthorizationResponse', res.data);

      return await dispatch('checkUserAndOnboardingStatus');
    } catch (e) {
      if (axios.isAxiosError(e) && [422].includes(e?.response?.status)) {
        // User needs to continue onboarding
        // check current user
        if (
          e?.response?.data?.message ===
            'please complete onboarding packet before continuing' &&
          e?.response?.data?.onboarding_packet_id > 0
        ) {
          commit('setPacketId', e?.response?.data?.onboarding_packet_id);
        }

        return await dispatch('checkUserAndOnboardingStatus');
      } else if (axios.isAxiosError(e) && [400].includes(e?.response?.status)) {
        // something is wrong with the oauth link
        return e.response;
      } else if (axios.isAxiosError(e) && [403].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  setConnectionInfo({ commit }, body) {
    return commit('setOnboardingConnection', body);
  },
};

// mutations
const mutations = {
  setAuthorizationResponse(state, auth) {
    state.authorization_response = auth;
  },
  setOnboardingConnection(state, connection) {
    state.onboarding_connection = connection;
  },
  setPacketId(state, packetId) {
    state.packet_id = packetId;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
